<template>

  <div class="modal"  id="discountModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
    <div class="modal-content">
      <div  style="background-color:#66CC99" class="modal-header border border-success rounded">
        <h5 class="modal-title"><strong>APPLICA % SCONTO</strong></h5>
      </div>
       <form v-on:submit.prevent="submit()">
      <div class="modal-body">

        <p><strong>Inserire la percentuale di sconto </strong></p>
          
          <div class="form-group">
            <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">%</div>
            </div>
            <!--<label for="formGroupExampleInput">Sconto</label>-->
            <input ref="input1" type="number" step="1" class="form-control" id="inputDiscount" placeholder="Sconto" v-model="discount">
             
          </div>
          <small style="color:red" v-if="msg" id="codeHelp" class="form-text">
            <strong>SCONTO NON VALIDO</strong>
          </small>
          </div>

          
            <toolBar class="ml-4" @update="setData"></toolBar>    
          
      </div>
      

      <div class="modal-footer">

         <button @click="closeModal()" type="button" class="btn btn-secondary" >CHIUDI</button>
         <button  type="submit" class="btn btn-primary">
           <i  class="fas fa-check-circle mr-3" aria-hidden="true"></i>
           APPLICA</button>

      </div>
       </form>  


    </div>
  </div>
  </div>
  <!-- DISCOUNT -->
</template>

<script>
import toolBar  from '@/components/frontOffice/ToolBarDiscount/ToolBarDiscount.vue'
export default {

  components: {toolBar
  
  },
  data () 
  {
    return {
     discount : 0,
     msg      : false
    }
  },

 
  created: function()
  {
    this.$nextTick(() => {                  
        $('#discountModal').modal('show')   
        this.$refs.input1.focus() 
        this.$refs.input1.select() 
       
    })  
  },
  methods :
  {
    closeModal()
    {
      $('#discountModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    },  
    setData(data)
    {
      this.discount = data
    },
    submit()
    {
      
      this.msg      = false
      this.discount = isNaN(parseInt(this.discount)) ? 0 : this.discount            
      if(Number(parseInt(this.discount)) > 100)
      {
        
        this.msg = true
        return
      }
      $('#discountModal').modal('hide')          
      this.$emit('update',this.discount)
    }
  }
}
</script>    
<style scoped>
.modal-footer {  
  justify-content: space-between;  
}

</style>
